import React, { useState } from "react";
import { Send, ChevronDown, ChevronRight, X, Check, MapPin } from "lucide-react";
import { useCity } from "../context/CityContext";
import { useI18n } from "../context/I18nContext";
import BottomSheet from "./BottomSheet";

// City picker. Two presentations, same selection + persistence + modal:
//   variant "pill" -> compact control [paper-plane] City ▼  (legacy header style)
//   variant "row"  -> settings row  [pin] Grad ............ City >
export function CitySelector({ dark = false, variant = "pill" }) {
  const { cities, selectedCityId, selectedCity, selectCity } = useCity();
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  if (!cities.length) return null;

  const trigger = variant === "row" ? (
    <button data-testid="city-selector" onClick={() => setOpen(true)}
      className="mt-2 w-full flex items-center justify-between bg-slate-100 rounded-2xl px-4 py-3.5 font-semibold">
      <span className="flex items-center gap-2"><MapPin size={18} className="text-brand-red" /> {t("acct.city", "Grad")}</span>
      <span className="flex items-center gap-1.5 text-slate-500">
        <span data-testid="city-selector-name">{selectedCity?.name || "—"}</span>
        <ChevronRight size={18} />
      </span>
    </button>
  ) : (
    <button data-testid="city-selector" onClick={() => setOpen(true)}
      className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 font-bold text-sm transition-colors min-w-0 max-w-[42vw] ${dark ? "bg-white/15 hover:bg-white/25 text-white" : "bg-slate-100 hover:bg-slate-200 text-slate-800"}`}>
      <Send size={15} className="-rotate-12 shrink-0" />
      <span data-testid="city-selector-name" className="truncate">{selectedCity?.name || "—"}</span>
      <ChevronDown size={15} className="shrink-0" />
    </button>
  );

  return (
    <>
      {trigger}
      {open && (
        <BottomSheet open={open} onClose={() => setOpen(false)} testId="city-sheet" zIndex={60}
          maxHeight="max-h-[80vh]" label={t("city.choose_title", "Izaberi grad")}>
          <div className="p-5 overflow-y-auto overscroll-contain">
            <div className="flex items-center justify-between mb-3">
              <h3 className="font-display font-black text-lg text-slate-900">{t("city.choose_title", "Izaberi grad")}</h3>
              <button data-testid="city-sheet-close" onClick={() => setOpen(false)} className="bg-slate-100 rounded-full p-2"><X size={18} /></button>
            </div>
            <div className="space-y-2">
              {cities.map((c) => (
                <button key={c.id} data-testid={`city-option-${c.id}`}
                  onClick={() => { selectCity(c.id); setOpen(false); }}
                  className={`w-full flex items-center justify-between rounded-2xl px-4 py-3 font-bold ${c.id === selectedCityId ? "bg-brand-red/10 text-brand-red" : "bg-slate-100 text-slate-800"}`}>
                  <span className="flex items-center gap-2"><Send size={15} className="-rotate-12" /> {c.name}</span>
                  {c.id === selectedCityId && <Check size={18} />}
                </button>
              ))}
            </div>
          </div>
        </BottomSheet>
      )}
    </>
  );
}
